import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import moment from "moment";
import DialogContainer from "../../../containers/DialogContainer";
//actions
import * as shootActions from "../../../redux/actions/shootsactions";
import * as shootService from "../../../services/shootService";

class SendToContractorDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shoot: {
        shooter: {}
      },
      shots: {
        photo: 0,
        video: 0
      },
      languages: [],
      services: [],
      staffs: [],
      questions: [],
      packages: [],
      fetching: false,
      fetched: false,
      failed: false
    };
  }

  getShootDetails = async () => {
    try {
      console.log("getting shots");
      // this.props.shootActions.getOneShoot(this.props.match.params.name, this.props.match.params.date);

      if (!this.state.fetching) this.setState({ fetching: true });
      let { name, date } = this.props.match.params;
      console.time("details");
      let detailRequest = shootService.getOneShoot(
        {
          clinic: name,
          created_at: date
        },
        {
          params: {
            type: "details"
          }
        }
      );
      let languageRequest = shootService.getShootLanguages({ clinic: name, created_at: date });
      let serviceRequest = shootService.getShootServices({ clinic: name, created_at: date });
      let staffRequest = shootService.getShootStaff({ clinic: name, created_at: date });
      let questionRequest = shootService.getShootQuestions({ clinic: name, created_at: date });
      let packageRequest = shootService.getShootPackages({ clinic: name, created_at: date });
      let [detail, language, service, staff, question, packages] = await Promise.all([
        detailRequest,
        languageRequest,
        serviceRequest,
        staffRequest,
        questionRequest,
        packageRequest
      ]);
      this.setState({
        shoot: detail.data.shoot,
        shots: {
          photo: detail.data.photo,
          video: detail.data.video
        },
        languages: language.data,
        services: service.data,
        staffs: staff.data,
        questions: question.data,
        packages: packages.data,
        fetching: false,
        failed: false,
        fetched: true
      });
      console.timeEnd("details");
    } catch (err) {
      console.log(err);
      this.setState({ fetching: false, failed: true, fetched: false });
    }
  };

  startShoot = () => {
    this.props.shootActions.startShoot(this.props.match.params.name, this.props.match.params.date, {
      address: this.props.details.address,
      date: this.props.details.date,
      status: "PENDING"
    });
  };

  onExit = () => {
    this.setState({
      shoot: {
        shooter: {}
      },
      shots: {
        photo: 0,
        video: 0
      },
      languages: [],
      services: [],
      staffs: [],
      questions: [],
      packages: []
    });
  };

  render() {
    const { props } = this;
    let { shoot, languages, services, staffs, questions, packages, shots } = this.state;
    let { shooter } = shoot;
    return (
      <DialogContainer
        open={props.open}
        title="Send to Contractors"
        contentText={`You are about to send/start this shoot to the contractors. Please confirm if you want to do this action.`}
        actions={
          <DialogActions>
            <Button variant="flat" onClick={this.props.shootActions.closeStartShootDialog} color="secondary">
              Cancel
            </Button>
            <Button variant="flat" color="primary" onClick={() => this.startShoot(true)}>
              Start
              {this.props.updating ? <CircularProgress size={12} color="primary" style={{ marginLeft: 5 }} /> : null}
            </Button>
          </DialogActions>
        }
        onEnter={this.getShootDetails}
        onExit={this.onExit}
        fullWidth
      >
        {this.state.fetching ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress color="primary" />
          </div>
        ) : (
          <React.Fragment>
            <Typography variant="h5" style={{ margin: "10px 0px" }}>
              Review
            </Typography>
            <Paper style={{ padding: 24, width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Client Name</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {shoot.clinic}
                  </Typography>
                </div>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Company</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {shoot.company ? shoot.company : `Freelance (${shooter.given_name || ""} ${shooter.family_name || ""})`}
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Address</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {shoot.address}
                  </Typography>
                </div>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Shoot Date</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {moment(parseInt(shoot.date)).format("MMM D, YYYY hh:mm A")}
                  </Typography>
                </div>
              </div>
              {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Photo Shots</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {shots.photo}
                  </Typography>
                </div>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Video Shots</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {shots.video}
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Languages</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {languages.length}
                  </Typography>
                </div>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Services</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {services.length}
                  </Typography>
                </div>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                  <Typography variant="h5">Staffs</Typography>
                  <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                    {staffs.length}
                  </Typography>
                </div>
              </div>
             */}
            </Paper>
          </React.Fragment>
        )}
      </DialogContainer>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, failed, updating, startShoot, ...startShootDetails } = state.selectedShoot;
  return {
    router: state.router,
    ...startShoot,
    ...startShootDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendToContractorDialog);
